var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8602 1.27414C12.9713 0.893463 12.0179 0.703125 11 0.703125C9.98208 0.703125 9.02867 0.893463 8.13979 1.27414C7.2509 1.65482 6.46953 2.17648 5.7957 2.83914C5.1362 3.4877 4.6129 4.24905 4.22581 5.1232C3.85305 5.99734 3.66667 6.93494 3.66667 7.93597C3.66667 8.66913 3.77419 9.37408 3.98925 10.0508C4.2043 10.7276 4.50538 11.348 4.89247 11.9119L11 22.3594L17.2366 11.7427C17.5806 11.1929 17.8459 10.5937 18.0323 9.9451C18.233 9.29654 18.3333 8.62683 18.3333 7.93597C18.3333 6.93494 18.147 5.99734 17.7742 5.1232C17.3871 4.24905 16.8566 3.4877 16.1828 2.83914C15.5233 2.17648 14.7491 1.65482 13.8602 1.27414ZM11 11.5383C13.027 11.5383 14.6703 9.92233 14.6703 7.92892C14.6703 5.93552 13.027 4.31955 11 4.31955C8.97298 4.31955 7.32975 5.93552 7.32975 7.92892C7.32975 9.92233 8.97298 11.5383 11 11.5383Z",
    fill: "#0E376E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.62ef94959916e942faec488a4bc3e613.svg";
export { ForwardRef as ReactComponent };